<template>
  <div class="running-game-container">
    <a class="back-button" @click="goBack">⬅ {{back_label[language]}}</a>

    <div class="game-stats">
      <div class="game-info">{{score_label[language]}}: {{ score }}</div>
      <div class="multiplier">Multiplier: x{{ multiplier }}</div>
      <div class="timer">{{ timeleft_label[language] }}: {{ timeLeft }}s</div>
    </div>

    <div class="timer-bar-container">
      <div class="timer-bar" :style="{ width: (timeLeft / 60) * 100 + '%' }"></div>
    </div>

    <div class="ar-view">
      <video id="input_video" autoplay playsinline></video>
      <canvas id="output_canvas"></canvas>
    </div>

    <div v-if="isGameOver" class="game-over-overlay">
      <p>{{ overlayMessage }}</p>
      <button @click="startGame">Restart</button>
      <button @click="goBack">Go Back</button>
    </div>

    <div v-if="timeLeft === 60 && !isGameOver" class="instruction-overlay">
      <!-- <p>
        {{
          {
            en: "Raise your knees to run! Faster steps = Higher score!",
            el: "Σήκωσε τα γόνατά σου για να τρέξεις! Γρηγορότερα βήματα = Υψηλότερη βαθμολογία!",
            it: "Alza le ginocchia per correre! Passi più veloci = punteggio più alto!",
            ro: "Ridică-ți genunchii pentru a alerga! Pași mai rapizi = scor mai mare!",
            uk: "Піднімай коліна, щоб бігти! Швидші кроки = вищий бал!"
          }[language]
        }}
      </p> -->
    </div>

    <div v-if="promptMessage" class="prompt-message">
      {{ promptMessage[language] }}
    </div>

    <MorningWinOverlay :message="overlayMessage[language]" :visible="isMorningWinOverlayVisible" />
    <MorningLoseOverlay :message="overlayMessage[language]" :visible="isMorningLoseOverlayVisible" />
    <NoonWinOverlay :message="overlayMessage[language]" :visible="isNoonWinOverlayVisible" />
    <NoonLoseOverlay :message="overlayMessage[language]" :visible="isNoonLoseOverlayVisible" />
    <AfternoonWinOverlay :message="overlayMessage[language]" :visible="isAfternoonWinOverlayVisible" />
    <AfternoonLoseOverlay :message="overlayMessage[language]" :visible="isAfternoonLoseOverlayVisible" />
    <EveningWinOverlay :message="overlayMessage[language]" :visible="isEveningWinOverlayVisible" />
    <EveningLoseOverlay :message="overlayMessage[language]" :visible="isEveningLoseOverlayVisible" />
    <ProfPepOverlay :message="overlayMessage[language]" :visible="isOverlayVisible" @start-game="onStartGame" />
  </div>
</template>


<script>
import { Camera } from "@mediapipe/camera_utils";
import { Pose } from "@mediapipe/pose";
import { Howler } from 'howler';
import { sounds } from '@/utils/sounds';
import ProfPepOverlay from '@/components/ProfPepOverlay.vue';
import MorningWinOverlay from '@/components/MorningWinOverlay.vue';
import MorningLoseOverlay from '@/components/MorningLoseOverlay.vue';
import NoonWinOverlay from '@/components/NoonWinOverlay.vue';
import NoonLoseOverlay from '@/components/NoonLoseOverlay.vue';
import AfternoonWinOverlay from '@/components/AfternoonWinOverlay.vue';
import AfternoonLoseOverlay from '@/components/AfternoonLoseOverlay.vue';
import EveningWinOverlay from '@/components/EveningWinOverlay.vue';
import EveningLoseOverlay from '@/components/EveningLoseOverlay.vue';

export default {
  components: {
    ProfPepOverlay,
    MorningWinOverlay,
    MorningLoseOverlay,
    NoonWinOverlay,
    NoonLoseOverlay,
    AfternoonWinOverlay,
    AfternoonLoseOverlay,
    EveningWinOverlay,
    EveningLoseOverlay,
  },
  data() {
    return {
isShuttingDown: false,
      back_label : {en:"Back", el:"Πίσω", it:"Indietro", ro:"Înapoi", uk:"Назад"},
     Round_label: {en:"Round", el:"Γύρος", it:"Round", ro:"Rundă", uk:"Раунд"},
      timeleft_label: {en:"Time left", el:"Χρόνος", it:"Tempo rimanente", ro:"Timp rămas", uk:"Час залишився"},
      score_label: {en:"Score", el:"Πόντοι", it:"Punteggio", ro:"Scor", uk:"Очки"},
      correct_label: {en:"Correct!", el:"Σωστά!", it:"Corretto", ro:"Corect!", uk:"Правильно!"},
      wrong_label: {en:"Wrong...", el:"Λάθος...", it:"Sbagliato", ro:"Greșit...", uk:"Неправильно..."},

      isSyncing: false,

      camera: null,
      score: 0,
      multiplier: 1,
      scoreThreshold: 100,
      timeLeft: 60,
      isRunning: false,
      isGameOver: false,
      lastValidStepTime: null,
      overlayMessage: "",
      promptMessage: {
        en: "Get Ready to Run!",
        el: "Ετοιμάσου να τρέξεις!",
        it: "Preparati a correre!",
        ro: "Pregătește-te să alergi!",
        uk: "Приготуйся бігти!"
      },
      isRightStepActive: false,
      isLeftStepActive: false,
      stepCount: 0,
      showThresholdFeedback: false, // Flag for threshold feedback
      isOverlayVisible: true,
      isMorningWinOverlayVisible: false,
      isMorningLoseOverlayVisible: false,
      isNoonWinOverlayVisible: false,
      isNoonLoseOverlayVisible: false,
      isAfternoonWinOverlayVisible: false,
      isAfternoonLoseOverlayVisible: false,
      isEveningWinOverlayVisible: false,
      isEveningLoseOverlayVisible: false,
    };
  },
  methods: {
    async goBack() {
      // Guard: If start overlay is still visible, just play whoosh and go back without affecting score/seed points.
      if (this.isOverlayVisible) {
        sounds.whoosh.play();
        this.$router.push({ name: 'GameSelection' });
        return;
      }
      sounds.whoosh.play();
      sounds.drums_for_games_extended.stop();
      this.isShuttingDown = true;
      clearInterval(this.timer);
      clearInterval(this.frameTimer);

      if (this.camera) {
        try {
          this.camera.stop();
        } catch (e) {
          console.error("Camera stop failed on unmount:", e);
        }
      }

      // Optionally nullify the camera and pose to prevent further usage
      this.camera = null;

      if (this.pose) {
        this.pose.close(); // dispose pose properly if using pose.setOptions() instance
        this.pose = null;
      }

      // End the game as if the time ran out
      await this.endGame();
    },
    startGame() {
      this.score = 0;
      this.multiplier = 1;
      this.timeLeft = 60;
      this.isRunning = false;
      this.isGameOver = false;
      this.lastValidStepTime = Date.now();
      this.stepCount = 0;
      this.promptMessage = {
        en: "Get Ready to Run!",
        el: "Ετοιμάσου να τρέξεις!",
        it: "Preparati a correre!",
        ro: "Pregătește-te să alergi!",
        uk: "Приготуйся бігти!"
      };
      this.overlayMessage = {en:'Get ready for some running in place!', el:'Ετοιμάσου για επιτόπου τρέξιμο!', it:'Preparati per correre sul posto!', ro:'Pregătește-te pentru alergat pe loc!', uk:'Приготуйся до бігу на місці!'}
      setTimeout(() => {
        this.promptMessage = "";
        this.initializeMediapipePose();
      }, 3000);
    },
    onStartGame() {
      // Hide the overlay and start the game logic
      Howler.ctx.resume();
      sounds.drums_for_games_extended.play();
      this.isOverlayVisible = false;
      this.score = 0;

      this.timeLeft = 60;
      this.startTimer();

      // Play a sound
      sounds.get_ready.play();
    },
    startTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.timeLeft--;
        if (this.timeLeft <= 0) {
          clearInterval(this.timer);
          this.endGame();
        }
      }, 1000);
    },
    initializeMediapipePose() {
      const videoElement = document.getElementById("input_video");
      const canvasElement = document.getElementById("output_canvas");
      if (!videoElement || !canvasElement) {
        console.error("Video or canvas element not found");
        return;
      }
      const canvasCtx = canvasElement.getContext("2d");

      // Match video and canvas dimensions to window
      videoElement.width = window.innerWidth;
      videoElement.height = window.innerHeight;
      canvasElement.width = window.innerWidth;
      canvasElement.height = window.innerHeight;

      const pose = new Pose({
        locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/pose/${file}`,
      });

      pose.setOptions({
        modelComplexity: 0,
        smoothLandmarks: true,
        enableSegmentation: false,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5,
      });


      pose.setOptions({
        modelComplexity: 0,
        smoothLandmarks: true,
        enableSegmentation: false,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5,
      });

      pose.onResults((results) => {
        canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
        canvasCtx.save();
        canvasCtx.scale(-1, 1); // Mirror canvas horizontally
        canvasCtx.translate(-canvasElement.width, 0); // Adjust for mirroring
        canvasCtx.drawImage(
          results.image,
          0,
          0,
          canvasElement.width,
          canvasElement.height
        );
        canvasCtx.restore();

        // Draw circles on hips and knees landmarks after restoring context, before checking running steps
        if (results.poseLandmarks) {
          const points = [23, 24, 25, 26]; // leftHip, rightHip, leftKnee, rightKnee
          canvasCtx.fillStyle = "lime";
          points.forEach(index => {
            const lm = results.poseLandmarks[index];
            const x = (1 - lm.x) * canvasElement.width; // adjust for mirror
            const y = lm.y * canvasElement.height;
            canvasCtx.beginPath();
            canvasCtx.arc(x, y, 5, 0, 2 * Math.PI);
            canvasCtx.fill();
          });
        }

        if (results.poseLandmarks) {
          this.checkRunningSteps(results.poseLandmarks);

          // Draw threshold feedback if active
          if (this.showThresholdFeedback) {
            const rightHip = results.poseLandmarks[24];
            const leftHip = results.poseLandmarks[23];
            const hipThreshold = ((rightHip.y + leftHip.y) / 2) * canvasElement.height;

            canvasCtx.beginPath();
            canvasCtx.moveTo(0, hipThreshold);
            canvasCtx.lineTo(canvasElement.width, hipThreshold);
            canvasCtx.strokeStyle = "red";
            canvasCtx.lineWidth = 2;
            canvasCtx.stroke();
          }
        } else {
          this.promptMessage = {
            en: "Adjust your position to make hips and knees visible!",
            el: "Ρύθμισε τη θέση σου ώστε να φαίνονται οι γοφοί και τα γόνατα!",
            it: "Regola la posizione per rendere visibili fianchi e ginocchia!",
            ro: "Ajustează-ți poziția pentru a face șoldurile și genunchii vizibili!",
            uk: "Відкоригуйте положення, щоб стегна та коліна були видимі!"
          };
        }
      });

      this.camera = new Camera(videoElement, {
        onFrame: async () => {
          await pose.send({ image: videoElement });
        },
        width: 320,
        height: 180,
      });

      this.camera.start();
    },
    checkRunningSteps(landmarks) {
      const rightKnee = landmarks[26];
      const leftKnee = landmarks[25];
      const rightHip = landmarks[24];
      const leftHip = landmarks[23];

      if (!rightKnee || !leftKnee || !rightHip || !leftHip) {
        this.promptMessage = {
          en: "Adjust your position to make hips and knees visible!",
          el: "Ρύθμισε τη θέση σου ώστε να φαίνονται οι γοφοί και τα γόνατα!",
          it: "Regola la posizione per rendere visibili fianchi e ginocchia!",
          ro: "Ajustează-ți poziția pentru a face șoldurile și genunchii vizibili!",
          uk: "Відкоригуйте положення, щоб стегна та коліна були видимі!"
        };
        return;
      }

      const hipThreshold = ((rightHip.y + leftHip.y) / 2) * window.innerHeight;
      const rightKneeHeight = rightKnee.y * window.innerHeight;
      const leftKneeHeight = leftKnee.y * window.innerHeight;

      let stepDetected = false;

      if (rightKneeHeight < hipThreshold) {
        if (!this.isRightStepActive) {
          this.score += this.multiplier;
          this.multiplier++;
          this.isRightStepActive = true;
          stepDetected = true;
        }
      } else {
        this.isRightStepActive = false;
      }

      if (leftKneeHeight < hipThreshold) {
        if (!this.isLeftStepActive) {
          this.score += this.multiplier;
          this.multiplier++;
          this.isLeftStepActive = true;
          stepDetected = true;
        }
      } else {
        this.isLeftStepActive = false;
      }

      if (stepDetected) {
        this.stepCount++;
        this.lastValidStepTime = Date.now();

        if (this.stepCount % 5 === 0) {
          this.showThresholdFeedback = true;
          setTimeout(() => {
            this.showThresholdFeedback = false;
          }, 2000);
        }
      }

      const timeSinceLastStep = Date.now() - this.lastValidStepTime;
      if (timeSinceLastStep > 1000) {
        this.multiplier = 1;
        this.promptMessage = {
          en: "Run Faster!",
          el: "Τρέξε πιο γρήγορα!",
          it: "Corri più veloce!",
          ro: "Aleargă mai repede!",
          uk: "Біжи швидше!"
        };
      }
    },
    async updateSeedPoints(seedType, change) {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const response = await fetch("https://erebus2.athenarc.gr/duse/update-seed-points", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ seedType, change }),
    });

    if (response.ok) {
      console.log(`Seed points updated: ${change} to ${seedType}`);
    } else {
      console.error("Failed to update seed points.");
    }
  } catch (error) {
    console.error("Error updating seed points:", error);
  }
},
    async endGame() {
      sounds.drums_for_games_extended.stop();
      let seedType = "";
      let change = 0;

      if (this.score > this.scoreThreshold) {
        change = 1; // Win: Gain a seed
      } else {
        change = -1; // Lose: Lose a seed
      }
      if (this.score > this.scoreThreshold) {
        // Play a sound
        sounds.win_sound.play();
      } else {
        // Play a sound
        sounds.lose_sound.play();
      }
      if (this.daypart == 'morning') {
        seedType = "blue";

        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isMorningWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isMorningLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'noon') {
        seedType = "red";

        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isNoonWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isNoonLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'afternoon') {
        seedType = "green";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isAfternoonWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isAfternoonLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'night') {
        seedType = "yellow";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isEveningWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isEveningLoseOverlayVisible = true; // Show overlay at the end
        }
      }
      // Send seed update to the backend
      await this.updateSeedPoints(seedType, change);

      setTimeout(() => {
        this.$router.push({ name: 'GameSelection' }); // Redirect after delay
      }, 3000); // 3 seconds delay
    },


    async storeInIndexedDB(gameState) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);
    request.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("gameStates")) {
        db.createObjectStore("gameStates", { keyPath: "id", autoIncrement: true });
      }
    };

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readwrite");
      const store = transaction.objectStore("gameStates");

      // Check for existing game state before saving
      const getAllRequest = store.getAll();
      getAllRequest.onsuccess = function () {
        const existingRecords = getAllRequest.result;
        const duplicate = existingRecords.find(
          (record) => record.gameName === gameState.gameName && record.datePlayed === gameState.datePlayed
        );

        if (!duplicate) {
          store.add(gameState);
        } else {
          console.warn("Duplicate game state detected. Skipping save.");
        }

        resolve();
      };

      getAllRequest.onerror = function (event) {
        reject("Error checking existing records:", event.target.error);
      };
    };

    request.onerror = function (event) {
      reject("Error opening IndexedDB:", event.target.error);
    };
  });
}
,

async getUnsyncedGameStates() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readonly");
      const store = transaction.objectStore("gameStates");

      const getAllRequest = store.getAll();
      getAllRequest.onsuccess = function () {
        resolve(getAllRequest.result);
      };
      getAllRequest.onerror = function (event) {
        reject("Error retrieving game states:", event.target.error);
      };
    };
  });
},

async deleteSyncedGameStates(syncedGames) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readwrite");
      const store = transaction.objectStore("gameStates");

      syncedGames.forEach((game) => {
        store.delete(game.id); // Delete only specific records
      });

      resolve();
    };

    request.onerror = function (event) {
      reject("Error clearing IndexedDB:", event.target.error);
    };
  });
}
,
async syncWithMongo() {
  if (this.isSyncing) return; // Prevent duplicate sync
  this.isSyncing = true;

  const token = localStorage.getItem("token");
  if (!token) {
    console.error("User not authenticated. Cannot sync.");
    this.isSyncing = false;
    return;
  }

  try {
    const unsyncedGames = await this.getUnsyncedGameStates();
    if (unsyncedGames.length === 0) {
      console.log("No game states to sync.");
      this.isSyncing = false;
      return;
    }

    const response = await fetch("https://erebus2.athenarc.gr/duse/save-game-state", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ gameStates: unsyncedGames }),
    });

    if (response.ok) {
      console.log("Game states synced successfully.");
      await this.deleteSyncedGameStates(unsyncedGames);
    } else {
      console.error("Failed to sync game states.");
    }
  } catch (error) {
    console.error("Error syncing with MongoDB:", error);
  } finally {
    this.isSyncing = false; // Ensure flag is reset
  }
},
    async saveGameState() {
  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");

  if (!username) {
    console.error("User not logged in. Cannot save game state.");
    return;
  }

  const gameState = {
    username,
    gameName: this.$route.name,
    score: this.score,
    datePlayed: new Date().toISOString(),
  };

  try {
    // Store in IndexedDB regardless of network status
    await this.storeInIndexedDB(gameState);

    if (navigator.onLine && token) {
      await this.syncWithMongo();
    } else {
      console.warn("No internet connection. Game state saved locally.");
    }
  } catch (error) {
    console.error("Error saving game state:", error);
  }
},

  },
  created()
  {
    this.language = localStorage.getItem("language") || "en"; // Default to English
    console.log("LANGUAGE "+this.language);
  },
  mounted() {
  console.log("Current route path:", this.$route.path);

  const daypart = this.$route.path.split("/")[2] || "daypart";
  this.daypart = daypart;
  this.startGame();

  // Check for internet connectivity
  window.addEventListener("online", async () => {
    console.log("Back online! Syncing game states...");
    await this.syncWithMongo();
  });
},
  beforeUnmount() {
    clearInterval(this.timer);
    if (this.camera) {
      try {
        this.camera.stop();
      } catch (e) {
        console.error("Camera stop failed on unmount:", e);
      }
    }

    // Optionally nullify the camera and pose to prevent further usage
    this.camera = null;

    if (this.pose) {
      this.pose.close(); // dispose pose properly if using pose.setOptions() instance
      this.pose = null;
    }
    this.saveGameState();
  },
  beforeRouteLeave(to, from, next) {
    // Save game state when the user navigates away
    this.saveGameState();
    next();
  },


};
</script>


<style scoped>
.running-game-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  overflow: hidden;
  /* Ensure content doesn't overflow the container */
}

.ar-view {
  position: relative;
  width: 100%;
  height: 100%;
}

video,
canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  /* Maintain aspect ratio */
  height: 100%;
  /* Full height of the screen */
  object-fit: cover;
  /* Avoid distortion */
  transform: scaleX(-1);
  /* Mirror for selfie mode */
}


.game-stats {
  position: absolute;
  top: 70px;
  /* Fixed position to prevent being pushed */
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  /* Higher than video and canvas */
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  margin: 0 auto;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  color: white;
  font-size: 20px;
}

.timer-bar-container {
  position: absolute;
  top: 70px;
  /* Below the stats */
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  /* Same as game stats to ensure visibility */
  width: 90%;
  height: 10px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
}

.timer-bar {
  height: 100%;
  background: red;
  border-radius: 5px;
  transition: width 0.5s linear;
}

.game-over-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  z-index: 20;
  /* Ensure it is above everything */
}

.prompt-message {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: yellow;
  font-size: 24px;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 10px 20px;
  border-radius: 10px;
  text-align: center;
  z-index: 15;
}

.instruction-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  font-size: 18px;
  z-index: 15;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.back-button {
  z-index: 1001;
}
</style>